import { Attachment } from "./Attachment";
import { Common } from "./Common";

export class Business extends Common {

    name: string;
    gst: string;
    logo: string;
    app: string;
    type: string;
    category: string[];
    tag: string[];
    category2: string;
    slogan: string;
    config: any;
    pur: string[];
    rishi: string[];
    community_image: any
}